import { AuthService } from '../services/auth.service';
export interface IDMDonViXuLy{
    Id:number,
    Ten:string,
    DiaChi:string,
    Fax:string,    
    DienThoai:string,   
    IdCoQuan:number,    
    TrangThai:number,
    TenCoQuan:string,
    Email:string,
    
}

export class DMDonViXuLy implements IDMDonViXuLy{
    Id:number = 0;
    Ten:string = "";   
    DiaChi:string = "";
    Fax:string = "";
    DienThoai:string = "";
    IdCoQuan:number = 0;    
    TrangThai:number = 1;
    TenCoQuan:string = "";
    Email:string="";

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
    
}

export class SearchDMDonViXuLy{    
    IdCoQuan:number = 0;
    keyword:string = "";
    maxSize:number = 3;    
    paging:number = 0;
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/dm-don-vi-xu-ly/dm-don-vi-xu-ly.ts